var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRhpIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "129px",
    viewBox: "0 0 129 129",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RHPIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Get-started---Desktop",
    transform: "translate(-713.000000, -244.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(574.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RHPIcon",
    transform: "translate(141.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 33.7498255,
    cy: 22.2608493,
    rx: 16.1245288,
    ry: 16.155714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7561078,0.0904539964 L68.2674857,0.0380003797 C61.5314812,-0.486535788 55.598213,4.47907326 54.9176323,11.2281053 C54.2196007,18.0995291 59.2105263,24.2191177 66.0686863,24.9184993 L66.260645,24.9534683 C85.3518079,26.7718604 100.289683,42.8751207 100.289683,62.4927734 C100.289683,83.3168592 83.4322211,100.206924 62.6657825,100.206924 C41.8993439,100.206924 25.0244311,83.3168592 25.0244311,62.4927734 C25.0244311,59.4679481 25.3559961,56.5130611 26.0365769,53.6980503 C27.43264,46.9490183 23.1048443,40.322378 16.3688399,38.9236149 C9.6328354,37.5248518 3.21094513,41.5637803 1.5531202,48.4701732 L1.48331705,48.7324413 C0.506072874,53.1210605 0,57.7020097 0,62.3878661 C0,78.6135183 6.16012844,93.3879536 16.2641351,104.50812 L14.2572944,118.845442 C14.2572944,118.897896 14.2398436,118.95035 14.2398436,119.002803 L14.2223929,119.072741 L14.2223929,119.072741 C14.2049421,119.247587 14.1874913,119.439917 14.1874913,119.632247 C14.1874913,122.289896 16.3339383,124.42301 18.9690074,124.42301 C19.667039,124.42301 20.3476197,124.265649 20.9409465,124.003381 L20.9583973,124.003381 L34.1860952,118.215999 C42.6846293,122.552165 52.3174647,125 62.5087254,125 C97.0263856,125 125,96.9722841 125,62.3878661 C124.982549,29.9365619 100.342035,3.237671 68.7561078,0.0904539964 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhpIcon);
export default __webpack_public_path__ + "static/media/RHPIcon.b6c937d65edf127b3731562c5c71a36c.svg";
export { ForwardRef as ReactComponent };